import {} from 'react';
import ReactDOM from 'react-dom';
import {IntlProvider} from 'react-intl';

import {messages, locale} from '@/locales';
import * as store from '@/store';
import {
    shareInviteDisplayType,
    ShareInviteModalSource,
    ShareInviteModalType,
} from '@/Constant';
import Dialog2 from '@/components/Dialog2';
import ShareSearchPopper from '@/components/shareCollaborate/search/searchContent';

import styles from './index.module.scss';

export function shareToRuLiu(url: string, editionUrlId?: string) {
    let rootEl: HTMLDivElement | null = document.createElement('div');
    document.body.appendChild(rootEl);

    function remove() {
        if (rootEl) {
            ReactDOM.unmountComponentAtNode(rootEl);
            document.body.removeChild(rootEl);
            rootEl = null;
        }
    }

    const repository = store.getCurRepository();
    const doc = store.getCurDocument();
    ReactDOM.render(<IntlProvider locale={locale} messages={messages.zh}>
        <Dialog2 className={styles.dialog} visible showFooter={false}>
            <ShareSearchPopper
                title="分享链接到如流"
                repository={repository!}
                docGuid={doc?.docGuid}
                shareContent={url}
                shareInviteConfig={{
                    source: ShareInviteModalSource.recentDocs,
                    type: ShareInviteModalType.share,
                    displayType: shareInviteDisplayType.popper,
                }}
                showCancel
                handleClose={remove}
                version={editionUrlId}
            />
        </Dialog2>
    </IntlProvider>, rootEl);
}
